import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { ForgotPassword } from 'app/shared/models/forgot-password.model';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPassword: ForgotPassword;
  protected forgotPasswordMessage: string;

  constructor(private authenticationService: AuthenticationService, private router: Router, protected translateService: TranslateService) {
  }

  ngOnInit() {
    this.initializeObject();
    this.translateService.get(['account.forgotPassword.forgotPasswordMessage'])
      .subscribe(translations => {
        this.forgotPasswordMessage = translations['account.forgotPassword.forgotPasswordMessage'];
      });
  }

  initializeObject() {
    if (this.forgotPassword == null) {
      this.forgotPassword = new ForgotPassword();
    }
  }

  onSubmit(form: NgForm) {
    this.authenticationService.forgotPassword(form.value, () => this.router.navigate(['/account/login']), this.forgotPasswordMessage);
  }
}
